const withDisableFlag = (list, activeList, key, labelKey) => {
  return list.map((item) => {
    const isActive = activeList.some((activeItem) => activeItem[key] === item[key])
    return {
      ...item,
      disable: !isActive,
      name: item[labelKey],
    }
  })
}

const sortByActive = (list, activeList, key) => {
  return list.sort((a, b) => {
    const aIsActive = activeList.some((item) => item[key] === a[key])
    const bIsActive = activeList.some((item) => item[key] === b[key])
    if (aIsActive === bIsActive) return 0
    return aIsActive ? -1 : 1
  })
}

export const prepareFilterList = (list, listKey, key, labelKey, activeFilterOptions) => {
  const activeList = activeFilterOptions[listKey] ?? []
  const withFlags = withDisableFlag(list, activeList, key, labelKey)
  return sortByActive(withFlags, activeList, key)
}
